import React, { useState } from 'react';
import { TableIds } from 'src/api/types/misc';
import Audit from 'src/components/Audit';
import ExpandSection from 'src/components/ExpandSection';

// Wires the shared Audit component to the BE's new `/api/public/api/audit/reports`
// endpoint via `rootPath="reports"`. The endpoint scopes entries to the active
// workspace and lists every export-related action (create / download / delete).
export const AuditSection: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <ExpandSection title="AUDIT" defaultOpen={false} onChange={setIsOpen} sectionId="report_centre_audit">
      {isOpen && (
        <div
          style={{
            maxHeight: '800px',
            position: 'relative',
          }}
        >
          <Audit
            rootPath="reports"
            // `initQuery` is required by Audit's effect-deps to avoid an infinite
            // refetch loop. The reports endpoint is workspace-scoped server-side,
            // so we pass {}.
            initQuery={{}}
            tableId={TableIds.auditReport}
            noHide
            topSpacer={0}
            maxHeight={800}
            toolbar
          />
        </div>
      )}
    </ExpandSection>
  );
};
